import { render, staticRenderFns } from "./healthIndex.vue?vue&type=template&id=ce7bc5bc&scoped=true"
import script from "./healthIndex.vue?vue&type=script&lang=js"
export * from "./healthIndex.vue?vue&type=script&lang=js"
import style0 from "./healthIndex.vue?vue&type=style&index=0&id=ce7bc5bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce7bc5bc",
  null
  
)

export default component.exports